import React, { useEffect, useState } from 'react'
import { obtenerPreguntasEvaluacionRetro, postRespuestasEvaluacionRetro } from '../services/evaluacion'
import { appState, setAlert, setLoading } from '../slices/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_FAIL, ALERT_SUCCESS } from '../app/constantes';
import InputComp from '../components/generales/inputComponent';
import { formatForm, validateForm } from '../app/commons';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmModal from '../components/generales/confirmModal';
import { ReactComponent as BackIcon } from '../assets/icons/back.svg';
import { getConsultores } from '../services/entidad';
import { retroState } from '../slices/retroSlice';

export const EncuestaRetroalimentacion = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const appSt = useSelector(appState);
    const retroSt = useSelector(retroState)
    const [form, setForm] = useState({});
    const [seccionesPreguntas, setSeccionesPreguntas] = useState([]);
    const [idEvaluacionRetroalimentacion, setIdEvaluacionRetroalimentacion] = useState(null);
    const [idRetroalimentacionInstrumento, setIdRetroalimentacionInstrumento] = useState(null);
    const [idPregustasPadres, setIdPregustasPadres] = useState([])
    const [isModalConfirmar, setIsModalConfirmar] = useState({
        show: false,
        title: "Confirmar",
        desc: "Una vez guardada la encuesta ya no podrá editar sus respuestas",
        action: null,
        btnDesc: "Aceptar"
    })
    const [catConsultores, setCatConsultores] = useState([]);
    useEffect(() => {
        dispatch(setLoading(false));
        setIdEvaluacionRetroalimentacion(null);
        const obtenerCatalogos = async () => {
            dispatch(setLoading(true));
            try {
                const consultores = await getConsultores(appSt.serviceData);
                let idRetroalimentacionInstrumento = location.search.split("?idRetroalimentacionInstrumento=")[1]
                setIdRetroalimentacionInstrumento(idRetroalimentacionInstrumento)
                const data = await obtenerPreguntasEvaluacionRetro({
                    ...appSt.serviceData,
                    idRetroalimentacionInstrumento
                })
                if (data.payload) {
                    if (!idRetroalimentacionInstrumento) {
                        dispatch(setAlert({
                            show: true,
                            message: "No existe el id retroalimentación instrumento",
                            type: ALERT_FAIL
                        }))
                        return
                    }
                    // se recorre para establecer el nuevo el form
                    let form = {};
                    for (let seccion of data.payload) {

                        for (let pregunta of seccion.pregunstasEvaluacionRetro) {
                            const data = {
                                value: pregunta.respuestasEvaluacion[0] 
                                ? pregunta.tipoNivelEvaluacion.cveTipoNivelEvaluacion.toLowerCase() === "textolibre" 
                                    ? pregunta.respuestasEvaluacion[0].valorRespuesta 
                                    : `${pregunta.respuestasEvaluacion[0].idNivelDesempenioRetro}` 
                                : "",
                                required: true,
                                message: 'Dato requerido',
                                tool: '',
                                invalid: false,
                            }
                            let respuestas = pregunta.respuestasEvaluacion.filter(resp => resp.evaluacionRetroalimentacion.idRetroalimentacionInstrumento.toString() === idRetroalimentacionInstrumento.toString());
                            setIdEvaluacionRetroalimentacion(respuestas[0] ? respuestas[0].evaluacionRetroalimentacion.idEvaluacionRetroalimentacion : null);
                            if (pregunta.cvePreguntaEvaluacionRetro === "dgNombreEmpresa") {
                                pregunta.disabled = true
                                data.value = retroSt.detailsRetro[0].razon_social
                            }
                            if (pregunta.cvePreguntaEvaluacionRetro === "dgAnioESR") {
                                pregunta.disabled = true
                                data.value = retroSt.detailsRetro[0].aniosParticipacion
                            }
                            if (pregunta.cvePreguntaEvaluacionRetro === "csrRetroalimentador") {
                                pregunta.disabled = true
                                data.value = retroSt.detailsRetro[0].retroalimentador
                            }
                            form[pregunta.cvePreguntaEvaluacionRetro] = data
                        }
                    }
                    setCatConsultores(consultores.payload);
                    setForm(form);
                    setSeccionesPreguntas(data.payload);
                    dispatch(setLoading(false));
                }
            } catch (error) {
                dispatch(setLoading(false));
                dispatch(setAlert({
                    show: true,
                    message: 'Error al obtener las preguntas',
                    type: ALERT_FAIL
                }))
            }
        }
        obtenerCatalogos();
    }, [])

    useEffect(() => {
        let idPregustasPadres = [];
        for (let seccion of seccionesPreguntas) {
            for (let pregunta of seccion.pregunstasEvaluacionRetro) {
                if (pregunta.tipoNivelEvaluacion.cveTipoNivelEvaluacion.toLowerCase() === "preguntasino"){
                    if (form[pregunta.cvePreguntaEvaluacionRetro].value) {
                        const nivel = pregunta.tipoNivelEvaluacion.nivelesEvaluacion.find(n => n.idNivelDesempenioRetro.toString() === form[pregunta.cvePreguntaEvaluacionRetro].value.toString())
                        if (nivel && nivel.cveNivelEvaluacion === "psnSi") {
                            idPregustasPadres.push(pregunta.idPreguntaEvaluacionRetro);
                        }
                    }
                }
                
            }
        }
        setIdPregustasPadres(idPregustasPadres);
    }, [form])
    

    const handleSubmit = async () => {
        if (!idRetroalimentacionInstrumento) {
            dispatch(setAlert({
                show: true,
                message: "No existe el id retroalimentación instrumento",
                type: ALERT_FAIL
            }))
            return
        }
        const valid = validateForm(obtenerNewForm());
        if (valid.length > 0) {
            dispatch(setAlert({
                show: true,
                message: "Favor de llenar los campos obligatorios",
                type: ALERT_FAIL
            }))
            return
        }
        const values = formatForm(form);
        // Se recorren las preguntas
        const respuestas = [];
        for (let seccion of seccionesPreguntas) {
            for (let pregunta of seccion.pregunstasEvaluacionRetro) {
                let valueForm = null
                for (let cvePreguntaEvaluacionRetro in values) {
                    if (pregunta.cvePreguntaEvaluacionRetro === cvePreguntaEvaluacionRetro) {
                        valueForm = values[cvePreguntaEvaluacionRetro];
                        break;
                    }
                }
                if (valueForm) {
                    if (pregunta.tipoNivelEvaluacion.cveTipoNivelEvaluacion.toLowerCase() !== "textolibre") {
                        const dataResp = { 
                            idPreguntaEvaluacionRetro: pregunta.idPreguntaEvaluacionRetro,
                            idNivelDesempenioRetro: valueForm
                        }
                        respuestas.push(dataResp);
                    } else {
                        respuestas.push({ 
                            idPreguntaEvaluacionRetro: pregunta.idPreguntaEvaluacionRetro,
                            idNivelDesempenioRetro: pregunta.tipoNivelEvaluacion.nivelesEvaluacion[0].idNivelDesempenioRetro,
                            respuestaTexto: valueForm
                        });
                    }
                }
            }
        }
        try {
            dispatch(setLoading(true))
            await postRespuestasEvaluacionRetro({
                ...appSt.serviceData,
                idRetroalimentacionInstrumento
            }, {
                nombreCompleto: values.csrNombrePersonaRetro,
                puestoCargo: values.dgPuestoCargo,
                nombreRetroalimentador: values.csrNombrePersonaRetro,
                aniosFundacion: values.dgAniosFuncionEmpresa,
                aniosEsr: values.dgAnioESR,
                idEvaluacionRetroalimentacion,
                respuestas,
            })
            setIsModalConfirmar({ ...isModalConfirmar, show: false });
            dispatch(setLoading(false));
            dispatch(setAlert({
                show: true,
                message: 'Se han guardado las respuestas exitosamente',
                type: ALERT_SUCCESS
            }))
            navigate(-1);
        } catch (error) {
            console.log(error);
            dispatch(setLoading(false));
            dispatch(setAlert({
                show: true,
                message: 'Error al realizar la operación',
                type: ALERT_FAIL
            }))
        }
    }
    const handleModalGuardarEncuesta = () => {
        const newForm = {...obtenerNewForm()};
        const valid = validateForm(newForm);
        if (valid.length > 0) {
            dispatch(setAlert({
                show: true,
                message: "Favor de llenar los campos obligatorios",
                type: ALERT_FAIL
            }))
            return
        }
        setIsModalConfirmar({ ...isModalConfirmar, show: true, action: handleSubmit, })
    }

    // Acción para cuando no sean requeridas
    const obtenerNewForm = () => {
        let newForm = { ...form };
        for (let seccion of seccionesPreguntas) {
            for (let pregunta of seccion.pregunstasEvaluacionRetro) {
                if (pregunta.idPreguntaEvaluacionPadre) {
                    const existePadre = idPregustasPadres.find(pp => pp === pregunta.idPreguntaEvaluacionPadre);
                    if (existePadre) {
                        newForm[pregunta.cvePreguntaEvaluacionRetro] = { ...form[pregunta.cvePreguntaEvaluacionRetro], required: true, invalid: false }
                    } else {
                        newForm[pregunta.cvePreguntaEvaluacionRetro] = { ...form[pregunta.cvePreguntaEvaluacionRetro], required: false, invalid: false }
                    }
                } else {
                    newForm[pregunta.cvePreguntaEvaluacionRetro] = { ...form[pregunta.cvePreguntaEvaluacionRetro], invalid: false }
                }
            }
        }
        return newForm;
    }
    return <main className="registro-consultor">
        <div
            className="main-section-title"
            style={{ display: "flex", alignItems: "flex-start" }}
        >
            <button onClick={() => navigate(-1)}>
                    <BackIcon />
                </button>
            <div className="text">
                <h3>Evaluación de retroalimentación</h3>
                <p>
                    La siguiente encuesta tiene como propósito evaluar la calidad del servicio de la sesión de retroalimentación brindada,
                    la efectividad de las recomendaciones y que esto le permita establecer un plan de mejora continua en responsabilidad social.
                </p>
                <p style={{ marginTop: 10 }}>
                    Es muy importante que responda con toda sinceridad, estos datos son de carácter confidencial y la información recabada se utilizará para fines estadísticos y mejorar el servicio.
                    <br />
                </p>
                <p style={{ marginTop: 10 }}>
                    <strong>Instrucciones:</strong> Conteste las preguntas de información general, posteriormente seleccione la calificación en cada casilla acorde a su opinión. No hay respuestas correctas o incorrectas estas simplemente reflejan su experiencia.
                </p>
            </div>
        </div>
        <div className="registro-consultor-card">
            <ul>
                {seccionesPreguntas.map(seccion => {
                    return <li key={seccion.idSeccionEvaluacionRetro}>
                        <h4>{seccion.descSeccionEvaluacionRetro}</h4>
                        <ul 
                            className='seccion-preguntas-respuestas'
                            style={{ marginLeft: 20, listStyle: "none" }}
                        >
                            {seccion.pregunstasEvaluacionRetro.map(pregunta => {
                                const existePadre = idPregustasPadres.find(pp => pp === pregunta.idPreguntaEvaluacionPadre);
                                if (!pregunta.idPreguntaEvaluacionPadre || existePadre)
                                    return <li ky={pregunta.idPreguntaEvaluacionRetro}>
                                        <div>
                                            {pregunta.tipoNivelEvaluacion.cveTipoNivelEvaluacion.toLowerCase() === "textolibre"
                                                ? pregunta.cvePreguntaEvaluacionRetro === "csrAyudaConsultor"
                                                    ? <InputComp
                                                        label={pregunta.descPreguntaEvaluacionRetro}
                                                        name={pregunta.cvePreguntaEvaluacionRetro}
                                                        type="select"
                                                        catalogos={catConsultores.map(c => ({...c, nombreCompleto: `${c.nombre} ${c.apellidoPaterno?.trim()} ${c.apellidoMaterno?.trim()}` }))}
                                                        catalogoLabel="nombreCompleto"
                                                        catalogoValue="idConsultorAcreditado"
                                                        form={form}
                                                        setForm={setForm}
                                                        disabled={idEvaluacionRetroalimentacion || pregunta.disabled}
                                                        value={pregunta.defaultValue ? pregunta.defaultValue : ""}
                                                        styleInput={{ color: "black" }}
                                                    />
                                                    : <InputComp
                                                        label={pregunta.descPreguntaEvaluacionRetro}
                                                        name={pregunta.cvePreguntaEvaluacionRetro}
                                                        type={["dgAnioESR", "dgAniosFuncionEmpresa"].includes(pregunta.cvePreguntaEvaluacionRetro) ? "number" : "upper"}
                                                        form={form}
                                                        disabled={pregunta.disabled}
                                                        value={pregunta.defaultValue ? pregunta.defaultValue : ""}
                                                        setForm={setForm}
                                                        readOnly={idEvaluacionRetroalimentacion}
                                                    />
                                                : [
                                                    "escalaprocesopostulacionesr", "escalaProcesoPostulacionRSE", "escalaEsquemaEvaluacion",
                                                    "preguntaSiNo", "ayudaRecibidaConsultor", "apoyoConsultorPostulacion", "desempenioConsultorPostulacion",
                                                    "etapaLlenadoInsttrumento", "escalaDesempenio"
                                                ].find(element => element.toLowerCase() === pregunta.tipoNivelEvaluacion.cveTipoNivelEvaluacion.toLowerCase())
                                                    ? <InputComp
                                                        label={pregunta.descPreguntaEvaluacionRetro}
                                                        name={pregunta.cvePreguntaEvaluacionRetro}
                                                        type="radioGroup"
                                                        catalogos={pregunta.tipoNivelEvaluacion.nivelesEvaluacion}
                                                        catalogoLabel="descNivelEvaluacion"
                                                        catalogoValue="idNivelDesempenioRetro"
                                                        form={form}
                                                        setForm={setForm}
                                                        disabled={idEvaluacionRetroalimentacion}
                                                        classNameInput={idEvaluacionRetroalimentacion ? "custom-disabled" : ""}
                                                    />
                                                    : <></>
                                            }
                                        </div>
                                    </li>
                                else return null;
                            })}
                        </ul>
                    </li>
                })}
            </ul>
            <div className="actions">
                {/* {data && !data.hideCancel && (
                    <button onClick={cancel}>Cancelar</button>
                )} */}
                <button 
                    disabled={idEvaluacionRetroalimentacion}
                    onClick={() => handleModalGuardarEncuesta()}
                >
                    Guardar
                </button>
            </div>
        </div>
        {isModalConfirmar.show &&
            <ConfirmModal 
                data={isModalConfirmar} 
                cancel={() => setIsModalConfirmar({ ...isModalConfirmar, show: false })} 
            />
        }
    </main>
}
